import { render, staticRenderFns } from "./usuarios.view.vue?vue&type=template&id=bd3f5a7e"
import script from "./usuarios.view.vue?vue&type=script&lang=js"
export * from "./usuarios.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports